export default "__VITE_ASSET__Bmv0KW3S__"